import { z } from 'zod';
import { NOTIFY_VOICES } from '../../ontology/objects/notification.ts';
import { idSchema } from '../../ontology/primitives.ts';
import { copySchema } from './copy.ts';
import { instant } from './primitives.ts';

export const wireNotificationSchema = z.object({
  id: idSchema,
  kind: z.string(),
  title: z.string(),
  copy: copySchema,
  action: z.string().nullable(),
  href: z.string().nullable(),
  voice: z.enum(NOTIFY_VOICES),
  about: z
    .object({
      recommendationId: idSchema,
      analystId: idSchema,
      bookId: idSchema,
      analyst: z.string(),
      book: z.string(),
    })
    .nullable(),
  createdAt: instant,
  readAt: instant.nullable(),
});

export type WireNotification = z.infer<typeof wireNotificationSchema>;

/** Notes just marked read, sent so open pages stamp them without the rows. */
export const readReceiptSchema = z.object({ ids: z.array(idSchema), at: instant });

export type ReadReceipt = z.infer<typeof readReceiptSchema>;

export const kindTallySchema = z.object({
  kind: z.string(),
  total: z.number().int(),
  unread: z.number().int(),
});

export type WireKindTally = z.infer<typeof kindTallySchema>;

export const inboxPageSchema = z.object({
  notifications: z.array(wireNotificationSchema),
  unread: z.number().int(),
  tally: z.array(kindTallySchema),
});

const telegramChatSchema = z.object({
  /** A private chat's id, which equals the user's Telegram account id. */
  chatId: z.number().int(),
  username: z.string().nullable(),
  name: z.string().nullable(),
});

export const telegramStateSchema = z.object({
  available: z.boolean(),
  botUsername: z.string().nullable(),
  link: telegramChatSchema
    .extend({
      linkedAt: instant,
      lastSentAt: instant.nullable(),
    })
    .nullable(),
});

export type TelegramState = z.infer<typeof telegramStateSchema>;

export const telegramLinkSchema = z.object({ url: z.url(), expiresAt: instant });

export type TelegramLinkOffer = z.infer<typeof telegramLinkSchema>;
